var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4352_21645",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4352_21645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.083 6.35399H5.91699V3.66699H15.083V6.35399ZM15.083 10.333C15.2917 10.333 15.469 10.2637 15.615 10.125C15.7603 9.98633 15.833 9.81266 15.833 9.60399C15.833 9.38199 15.7637 9.19799 15.625 9.05199C15.4863 8.90599 15.3127 8.83299 15.104 8.83299C14.882 8.83299 14.698 8.90599 14.552 9.05199C14.406 9.19799 14.333 9.37499 14.333 9.58299C14.333 9.79166 14.406 9.96899 14.552 10.115C14.698 10.2603 14.875 10.333 15.083 10.333ZM14 15.5V12.271H6.99999V15.5H14ZM15.083 16.583H5.91699V13.583H3.16699V8.83299C3.16699 8.40299 3.31966 8.03166 3.62499 7.71899C3.93033 7.40633 4.30533 7.24999 4.74999 7.24999H16.25C16.6947 7.24999 17.0697 7.40633 17.375 7.71899C17.6803 8.03166 17.833 8.40299 17.833 8.83299V13.583H15.083V16.583Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.67080b3a66c0a0ae59befbd5cba77406.svg";
export { ForwardRef as ReactComponent };